import { H3, LI, UL } from "../../../AbstractElements";
import { Followers, Following, Posts } from "../../../Constant";
import { UserCardsFooterProp } from "../../../Type/UserType";

const UserCardsFooter = ({ item }: UserCardsFooterProp) => {
  return (
      <UL className="social-follow simple-list d-flex flex-row justify-content-center">
        <LI><H3 className="mb-0">{item.follower}</H3><span className="f-light">{Posts}</span></LI>
        <LI><H3 className="mb-0">{item.following}k</H3><span className="f-light">{Followers}</span></LI>
        <LI><H3 className="mb-0">{item.totalPost}</H3><span className="f-light">{Following}</span></LI>
      </UL>
  );
};

export default UserCardsFooter;
